import { ReducerTypes } from "shared/types/reducerTypes";
import { Loaders } from "shared/types/loaders";

const wrapGlobalLoader = (
  func: () => Promise<any>,
  dispatch: any,
  loaderName: string = Loaders.globalLoader
) => {
  return async () => {
    dispatch({
      type: (ReducerTypes as any)[`start${loaderName}`],
    });

    try {
      await func();

      dispatch({
        type: (ReducerTypes as any)[`end${loaderName}`],
      });
    } catch (error) {
      dispatch({
        type: (ReducerTypes as any)[`end${loaderName}`],
      });
    }
  };
};

export default wrapGlobalLoader;
